import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [RollNo, setRollNo] = React.useState(FetchData.meta.roll_no)
  const [Name, setName] = React.useState(FetchData.meta.name)
  const [Email, setEmail] = React.useState(FetchData.meta.email)
  const [Phone, setPhone] = React.useState(FetchData.meta.phone)
  const [Photo, setPhoto] = React.useState(FetchData.meta.photo)
  const [Address, setAddress] = React.useState(FetchData.meta.address)
  const [IsActive, setIsActive] = React.useState(FetchData.meta.is_active)
  const [GuardianName, setGuardianName] = React.useState(FetchData.meta.guardian_name)
  const [GuardianPhone, setGuardianPhone] = React.useState(FetchData.meta.guardian_phone_number)
  const [AdmissionDate, setAdmissionDate] = React.useState(FetchData.meta.admission_date)
  const [CourseDetails, setCourseDetails] = React.useState(FetchData.meta.course_details == "" ? [] : JSON.parse(FetchData.meta.course_details))

  const [ShowCourseGroupList, setShowCourseGroupList] = React.useState(true)
  const [CourseSelectModal, setCourseSelectModal] = React.useState(false)
  const [CourseSelectIndex, setCourseSelectIndex] = React.useState(0)
  const [CourseSelectItem, setCourseSelectItem] = React.useState(false)
  const [CourseList, setCourseList] = React.useState([])

  const [PaymentHistory, setPaymentHistory] = React.useState(FetchData.meta.payment_history == "" ? [] : JSON.parse(FetchData.meta.payment_history))
  const [PaymentList, setPaymentList] = React.useState([])



  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "roll_no": `${RollNo}`,
        "name": `${Name}`,
        "email": `${Email}`,
        "phone": `${Phone}`,
        "photo": `${Photo}`,
        "address": `${Address}`,
        "is_active": `${IsActive}`,
        "guardian_name": `${GuardianName}`,
        "guardian_phone_number": `${GuardianPhone}`,
        "admission_date": `${AdmissionDate}`,
        "course_details": JSON.stringify(CourseDetails),
        "payment_history": JSON.stringify(PaymentHistory)
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_students)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Batch Added Successfully")
          history.push(`${slugs.students_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_students, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  useEffect(() => {
    getBatches()
    if (ID !== "")
      getPaymentHistory()
  }, [])

  const getBatches = () => {
    AdsGETApiAuth({
      _fields: "id,meta,title"
    }, slugs.db_slug_batches)
      .then((res) => {
        setCourseList(res.data)
      })
  }
  const getPaymentHistory = () => {
    AdsGETApiAuth({
      _fields: "id,meta,title,slug,date",
      "filter[meta_query][1][key]": "student_id",
      "filter[meta_query][1][value][0]": `${ID}`,
      "filter[meta_query][1][compare]": "=",
    }, slugs.db_slug_payments_received)
      .then((res) => {
        setPaymentList(res.data)
      })
  }


  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Batch Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Student Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Name} placeholder="Student Name"
                    onChange={(event) => { setName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Roll Number</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={RollNo} placeholder="Roll Number"
                    onChange={(event) => { setRollNo(event.target.value) }}
                  />
                  <div onClick={() => { setRollNo("") }}>
                    Reset Roll
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Email</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Email} placeholder="Email"
                    onChange={(event) => { setEmail(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Phone} placeholder="Phone Number"
                    onChange={(event) => { setPhone(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Photo</td>
                <td className="col-6">
                  <ImageUpload ImageUrl={Photo}
                    setImageUrl={setPhoto} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Address</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Address} placeholder="Address"
                    onChange={(event) => { setAddress(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">IsActive</td>
                <td className="col-6">
                  {/* <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Followup"} /> */}
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Advanced Payment"} />
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Full Payment"} />
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Course Completed"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Guardian Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={GuardianName} placeholder="Guardian Name"
                    onChange={(event) => { setGuardianName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Guardian Phone Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={GuardianPhone} placeholder="Guardian Phone Number"
                    onChange={(event) => { setGuardianPhone(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Admission Date</td>
                {/* <td className="col-6">
                  <input className="input-common" type="date"
                    value={AdmissionDate} placeholder="Name"
                    onChange={(event) => { setAdmissionDate(event.target.value) }}
                  />
                </td> */}
                <td className="nepali-date-cell">
                  {/* <div className="topic-popup"> */}
                  <div className="attendance-date-picker">
                    <div className="small-nepali-datepicker"
                    >
                      {/* {item.date} */}
                      <NepaliDatePicker style={{ cursor: "pointer" }}
                        inputClassName="input-common" placeholder={"date"}
                        value={AdmissionDate || ""}
                        onChange={(selectedDate) => {
                          setAdmissionDate(selectedDate)
                        }
                        }
                        options={{
                          calenderLocale: "ne",
                          valueLocale: "en",
                        }}
                        placeholder="मिति छान्नुहोस्"
                      // onSelect={() => { setOpencalendar(true) }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">Payment History</td>
                <td className="col-6">
                  <input className="input-common" type="date"
                    value={AdmissionDate} placeholder="Name"
                    onChange={(event) => { setAdmissionDate(event.target.value) }}
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Student
              </div>
            </div>
          </div>
        </div>
      </div >

      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Courses</center></h4>
          <table>
            <tr>
              <td>SN</td>
              <td>Course</td>
              <td>Batch</td>
              <td>Session</td>
              {/* <td>Price</td> */}
              <td>Joined Price</td>
              <td>Course Joined</td>
            </tr>
            <tbody>
              {Object.values(CourseDetails).map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td
                    onClick={() => {
                      setCourseSelectModal(true)
                      setCourseSelectItem(item)
                      setCourseSelectIndex(index)
                    }}
                  >
                    <div className="input-common">{item.course_name}&nbsp;</div>
                  </td>
                  <td
                    onClick={() => {
                      setCourseSelectModal(true)
                      setCourseSelectItem(item)
                      setCourseSelectIndex(index)
                    }}
                  >
                    <div className="input-common">{item.batch_name}&nbsp;</div>
                  </td>
                  <td
                    onClick={() => {
                      setCourseSelectModal(true)
                      setCourseSelectItem(item)
                      setCourseSelectIndex(index)
                    }}
                  >
                    <div className="input-common">{item.session}&nbsp;</div>
                  </td>
                  {/* <td>
                    <input className="input-common-items" disabled value={item.price} />
                  </td> */}
                  <td>
                    <input className="input-common" type="number"
                      value={item.course_joined_price} placeholder="Joining Price"
                      onChange={(event) => {
                        setCourseDetails({
                          ...CourseDetails,
                          [Object.keys(CourseDetails)[index]]: {
                            ...Object.values(CourseDetails)[index],
                            "course_joined_price": event.target.value
                          }
                        })
                      }}
                    />
                  </td>
                  {/* <td> */}
                  <td className="nepali-date-cell">
                    {/* <div className="topic-popup"> */}
                    <div className="attendance-date-picker">
                      <div className="small-nepali-datepicker"
                      >
                        {/* {item.date} */}
                        <NepaliDatePicker style={{ cursor: "pointer" }}
                          inputClassName="input-common" placeholder={"date"}
                          value={item.course_joined_date || ""}
                          onChange={(selectedDate) => {
                            // setAdmissionDate(selectedDate)
                            setCourseDetails({
                              ...CourseDetails,
                              [Object.keys(CourseDetails)[index]]: {
                                ...Object.values(CourseDetails)[index],
                                "course_joined_date": selectedDate
                              }
                            })
                          }
                          }
                          options={{
                            calenderLocale: "ne",
                            valueLocale: "en",
                          }}
                          placeholder="मिति छान्नुहोस्"
                        // onSelect={() => { setOpencalendar(true) }}
                        />
                      </div>
                    </div>
                    {/* </td> */}

                    {/* <input className="input-common" type="date"
                      value={item.course_joined_date} placeholder="Items"
                      onChange={(event) => {
                        setCourseDetails({
                          ...CourseDetails,
                          [Object.keys(CourseDetails)[index]]: {
                            ...Object.values(CourseDetails)[index],
                            "course_joined_date": event.target.value
                          }
                        })
                      }}
                    /> */}
                  </td>
                  <td>
                    <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                      var ObjectForDelete = CourseDetails
                      var key = Object.keys(CourseDetails)[index]
                      // console.log(key, Items)
                      delete ObjectForDelete[key];
                      setCourseDetails(ObjectForDelete)
                      setShowCourseGroupList(false)
                      setTimeout(() => {
                        setShowCourseGroupList(true)
                      }, 10)
                    }}>
                      Delete
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  var newValue = {
                    course_name: "",
                    batch_name: "",
                    session: "",
                    price: "",
                    course_joined_price: "",
                    course_joined_date: ""
                  }
                  var lastkey = Object.keys(CourseDetails).length == 0 ? -1 : Number(Object.keys(CourseDetails)[Object.keys(CourseDetails).length - 1])
                  var newKey = `${lastkey + 1}`
                  var newObject = CourseDetails;
                  newObject = {
                    ...CourseDetails,
                    [newKey]: newValue
                  }
                  // console.log(newObject)

                  setCourseDetails(newObject)
                }}
              >
                Add Course
              </div>
            </div>
          </div>
        </div>
      </div>
      {ID !== "" &&
        <div className="row">
          <div className="col-sm-2 col-1"></div>
          <div className="col-sm-8 col-10 form-view mb-3">
            <h4><center>Payment History</center></h4>
            {PaymentList.length !== 0 &&
              <table>
                <tr>
                  <td>Date</td>
                  <td>Receipt Number</td>
                  <td>Amount</td>
                  <td>Payment Mode</td>
                  <td>Details</td>
                </tr>
                {PaymentList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date.slice(0, 10)}</td>
                    <td>{item.meta.receipt_number}</td>
                    <td>{item.meta.amount}</td>
                    <td>{item.meta.payment_mode}</td>
                    <td><Link to={`${slugs.payments_received_details}${item.slug}`}>View</Link></td>
                  </tr>
                ))}
              </table>
            }
            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <Link to={`${slugs.new_payments_received}?student_id=${ID}`}>
                  <div className="sign-in-button-4"
                    onClick={() => {

                    }}
                  >
                    Add Payment
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      }


      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }

      {
        CourseSelectModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setCourseSelectModal(false)
                  }}
                >X</div>
                <div>
                  <table>
                    <tr>
                      <td>SN</td>
                      <td>Course</td>
                      <td>Batch</td>
                      <td>Session</td>
                    </tr>
                    {CourseList.map((item, index) => (
                      <tr key={index}
                        onClick={() => {

                          setCourseDetails({
                            ...CourseDetails,
                            [Object.keys(CourseDetails)[CourseSelectIndex]]: {
                              ...Object.values(CourseDetails)[CourseSelectIndex],
                              // "course_joined_date": event.target.value
                              course_name: item.meta.course_name,
                              batch_name: item.meta.batch_name,
                              session: item.meta.session_name,
                            }
                          })
                          const getPrefix = item.meta.prefix
                          setCourseSelectModal(false)
                          AdsGETApiAuth(
                            {
                              per_page: 10000,
                              _fields: "id,title,slug,meta"
                            }, slugs.db_slug_students)
                            .then((res) => {
                              var getlatestPrefix = res.data.filter(a => a.meta.roll_no.includes(getPrefix))
                              console.log(getlatestPrefix)
                              if (getlatestPrefix.length !== 0) {
                                var rollno = getlatestPrefix[0].meta.roll_no
                                console.log(rollno.slice("-")[1])
                                var RollNumber = Number(rollno.split("-")[1]) + 1
                                setRollNo(`${getPrefix}${RollNumber}`)

                              }
                              else {
                                setRollNo(`${getPrefix}2201`)
                              }
                            })
                        }}

                      >
                        <td>{index + 1}</td>
                        <td>{item.meta.course_name}</td>
                        <td>{item.meta.batch_name}</td>
                        <td>{item.meta.session_name}</td>

                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </div >
  )
}